class ParseUtil {
    static parseObjectToInfoTableArray(dataObj, titleMap) {
        return Object.keys(titleMap).map((key) => {
            return {
                title: titleMap[key], // titleMap에서 제목을 가져옴
                value: dataObj[key] || "-", // dataObj에서 값을 가져옴
            };
        });
    }

    static parseDateToString(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }

    static parseDateStringToRelativeTime(dateTimeString) {
        const targetDate = new Date(dateTimeString.replace(" ", "T"));
        const now = new Date();

        let diffMs = targetDate - now; // (목표 시간) - (현재 시간)

        const prefix = diffMs >= 0 ? "-" : "+";

        let absDiffMs = Math.abs(diffMs);

        const MS_PER_DAY = 1000 * 60 * 60 * 24;
        const MS_PER_HOUR = 1000 * 60 * 60;
        const MS_PER_MINUTE = 1000 * 60;

        const days = Math.floor(absDiffMs / MS_PER_DAY);
        absDiffMs = absDiffMs % MS_PER_DAY; // 일(day)을 계산하고 남은 밀리초

        const hours = Math.floor(absDiffMs / MS_PER_HOUR);
        absDiffMs = absDiffMs % MS_PER_HOUR; // 시간(hour)을 계산하고 남은 밀리초

        const minutes = Math.floor(absDiffMs / MS_PER_MINUTE);

        const parts = [];
        if (days > 0) {
            parts.push(`${days}d`);
        }
        if (hours > 0) {
            parts.push(`${hours}h`);
        }
        if (minutes > 0) {
            parts.push(`${minutes}m`);
        }

        if (parts.length === 0) {
            return "0m";
        }

        return `${prefix}${parts.join(" ")}`;
    }

    static formatDateTime(str) {
        // 데이터가 유효하지 않을 경우를 대비한 간단한 체크
        if (!str || str.length !== 14) return "유효하지 않은 입력입니다.";

        const year = str.substring(0, 4);
        const month = str.substring(4, 6);
        const day = str.substring(6, 8);
        const hour = str.substring(8, 10);
        const minute = str.substring(10, 12);
        const second = str.substring(12, 14);

        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    }

    static formatUserStatus(str) {
        if (str === "Y") {
            return "Approve";
        } else if (str === "C") {
            return "Reject";
        } else {
            return "Pending";
        }
    }

    static formatUserType(str) {
        const typeMap = {
            // Type 필터 value (camelCase)
            lgAdmin: "LG Admin",
            franchiseAdmin: "Franchise Admin",
            callCenter: "Call Center",
            shopOwner: "Shop Owner",
            // API role (snake_case)
            lg_admin: "LG Admin",
            franchise_admin: "Franchise Admin",
            franchise_manager: "Franchise Manager",
            store_owner: "Shop Owner",
            shop_owner: "Shop Owner",
            call_center: "Call Center",
        };
        if (typeMap[str]) return typeMap[str];

        if (str === "ADM037001") {
            return "Admin";
        } else if (str === "USR037001") {
            return "Shop Owner";
        } else if (str.endsWith("01")) {
            return "Franchise Manager";
        } else if (str.endsWith("02")) {
            return "Call Center";
        } else if (str.endsWith("03")) {
            return "Shop Owner";
        }
        return str;
    }

    // "{'17': 'DE1:Door Open Error'}" → "DE1 (Door Open Error)"
    static formatErrorCode(code) {
        if (!code) return "-";
        const match = code.match(/:\s*'([^']*)'/);
        const value = match ? match[1] : code;
        const idx = value.indexOf(":");
        if (idx === -1) return value;
        return `${value.slice(0, idx).trim()} (${value.slice(idx + 1).trim()})`;
    }
}

export default ParseUtil;
